import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"background":"#fff"} }
const _hoisted_2 = {
  class: "container",
  style: {"padding":"10px 20px","color":"gray"}
}
const _hoisted_3 = {
  class: "container mt15",
  style: {"padding":"0"}
}
const _hoisted_4 = {
  class: "flex-center",
  style: {"justify-content":"right"}
}
const _hoisted_5 = { style: {"padding":"20px"} }
const _hoisted_6 = { class: "flex-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  style: {"position":"relative","z-index":"1"},
  class: "i-ul"
}, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "#",
        title: "黑鸭点评 - 安心入职"
      }, "网站以公司评分为主导，各位职场前辈的经验为基石。帮助求职者们降低误入黑公司的概率。")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "#",
        title: "黑鸭点评 - 安心入职"
      }, "面试前、入职前搜一搜，了解公司背后的真实情况。")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "#",
        title: "黑鸭点评 - 安心入职"
      }, "信息共享，踩过的坑留下信息，让后人少走弯路。")
    ])
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" 少走弯路，努力去做开心的事情，然后奔赴星辰大海✨ "),
  /*#__PURE__*/_createElementVNode("div", {
    class: "mt5",
    style: {"text-align":"right"}
  }, " - 黑鸭")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex-center",
  style: {"justify-content":"space-between"}
}, [
  /*#__PURE__*/_createElementVNode("div", null, "友情链接")
], -1)
const _hoisted_10 = {
  style: {"position":"relative","z-index":"1"},
  class: "i-ul"
}
const _hoisted_11 = ["href", "title"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import {useRouter} from "vue-router";
import {reactive, onMounted} from 'vue';
import TopicCard from "@/components/TopicCard.vue";
import {getTopicsList} from "@/api/topics";
import {openLoading, closeLoading} from "@/utils/loadingToast";
import {getCommonDetail, getCommonGroup} from "@/api/other";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const router = useRouter();
const data = reactive({
    topicList: [],
    showSubType: false,
    query: {
        pageNum: 1,
        pageSize: 20,
        typeId: 0,
        orderColumn: 1
    },
    loading: false,
    topicTotal: 0,
    noticeInfo: undefined,
    friendLink: []
});

onMounted(async () => {
    getTopicsListData();
    await getNoticeInfo();
    await getFriendLink();
});

const getNoticeInfo = async () => {
    await getCommonDetail({configName: 'notice'}).then(res => {
        data.noticeInfo = res.data;
    })
}

const getFriendLink = async () => {
    await getCommonGroup({configGroupName: 'friendLink'}).then(res => {
        data.friendLink = res.data;
    })
}

const handleCurrentChange = (val: number) => {
    data.query.pageNum = val;
    getTopicsListData();
    document.documentElement.scrollTop = 0;
}

const getTopicsListData = () => {
    openLoading('加载中...');
    getTopicsList(data.query).then(res => {
        data.topicList = res.records;
        data.topicTotal = res.total;
        closeLoading();
    });
}

const changeType = (val: object) => {
    data.showSubType = true;
    data.query.typeId = val.value;
    getTopicsListData();
}

const changeTypeAll = () => {
    window.location.reload();
}

const dataSort = (val: number) => {
    data.query.orderColumn = val;
    data.query.pageNum = 1
    getTopicsListData();
}

const topicCateGoryList = [
    {
        label: '全部',
        value: 0,
    },
    {
        label: '交流分享',
        value: 100,
    },
    {
        label: '企业相关',
        value: 200,
    },
    {
        label: '个人相关',
        value: 300,
    },
    {
        label: '面经分享',
        value: 400,
    }
];

return (_ctx: any,_cache: any) => {
  const _component_el_link = _resolveComponent("el-link")!
  const _component_van_notice_bar = _resolveComponent("van-notice-bar")!
  const _component_Sort = _resolveComponent("Sort")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(topicCateGoryList, (item) => {
          return _createVNode(_component_el_link, {
            class: "mr10",
            onClick: ($event: any) => (changeType(item)),
            type: data.query.typeId===item.value?'primary':'info'
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.label), 1)
            ]),
            _: 2
          }, 1032, ["onClick", "type"])
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_row, {
        gutter: 15,
        class: "my-el-row"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            lg: 17,
            class: "my-el-col"
          }, {
            default: _withCtx(() => [
              (data.noticeInfo!=undefined)
                ? (_openBlock(), _createBlock(_component_van_notice_bar, {
                    key: 0,
                    "left-icon": "volume-o",
                    style: {"border-radius":"5px"},
                    color: data.noticeInfo.configValueB,
                    background: data.noticeInfo.configValueC,
                    text: data.noticeInfo.configValueA
                  }, null, 8, ["color", "background", "text"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_card, {
                shadow: "never",
                "body-style": { padding: '0px' }
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_text, {
                      class: "cu-pointer",
                      type: data.query.orderColumn===1?'primary':'info',
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (dataSort(1)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("最新回复 "),
                        (data.query.orderColumn===1)
                          ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Sort)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["type"]),
                    _createVNode(_component_el_text, {
                      class: "cu-pointer ml20",
                      type: data.query.orderColumn===0?'primary':'info',
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (dataSort(0)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("最新发布 "),
                        (data.query.orderColumn===0)
                          ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Sort)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["type"])
                  ])
                ]),
                default: _withCtx(() => [
                  (data.topicList.length===0)
                    ? (_openBlock(), _createBlock(_component_el_empty, {
                        key: 0,
                        "image-size": 50,
                        description: "空空如也"
                      }))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(data.topicList, (topic) => {
                        return (_openBlock(), _createBlock(TopicCard, {
                          topic: topic,
                          key: topic.uuid
                        }, null, 8, ["topic"]))
                      }), 128)),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_el_pagination, {
                      background: "",
                      layout: "prev, pager, next",
                      onCurrentChange: handleCurrentChange,
                      "current-page": data.query.pageNum,
                      "pager-count": "5",
                      "hide-on-single-page": "",
                      "page-size": data.query.pageSize,
                      total: data.topicTotal
                    }, null, 8, ["current-page", "page-size", "total"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            lg: 7,
            class: "hidden-sm-and-down my-el-col"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "never" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/topics/new" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        icon: "Edit",
                        round: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("发布新主题")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_card, {
                shadow: "never",
                class: "mt15 card-color"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_el_image, {
                      src: require('@/assets/logo.svg'),
                      style: {"width":"20px","height":"20px"}
                    }, null, 8, ["src"]),
                    _createVNode(_component_el_text, {
                      tag: "b",
                      type: "warning"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("黑鸭点评 - 安心入职")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_el_card, {
                shadow: "never",
                class: "mt15"
              }, {
                header: _withCtx(() => [
                  _createVNode(_component_el_text, { tag: "b" }, {
                    default: _withCtx(() => [
                      _createTextVNode("愿景")
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }),
              _createVNode(_component_el_card, {
                shadow: "never",
                class: "mt15"
              }, {
                header: _withCtx(() => [
                  _hoisted_9
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.friendLink, (link) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: link.uuid
                        }, [
                          _createElementVNode("a", {
                            href: link.configValueB,
                            title: link.configValueA
                          }, _toDisplayString(link.configValueA), 9, _hoisted_11)
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_card, {
                shadow: "never",
                class: "mt15"
              }, {
                header: _withCtx(() => [
                  _createVNode(_component_el_text, { tag: "b" }, {
                    default: _withCtx(() => [
                      _createTextVNode("免责声明")
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" 1.本站为非盈利性站点，所有内容不作为商业行为"),
                  _hoisted_12,
                  _createTextVNode(" 2.信息更新由当事者个人编辑，鱼龙混杂，不代表本站观点，仅供参考"),
                  _hoisted_13,
                  _createTextVNode(" 3.不得将本站内容用于商业或者非法用途，否则，一切后果请用户自负"),
                  _hoisted_14
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})